import progress from './progress';

export default {
  progress,
};
